.infoMessage {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  background-color: rgba(0,0,0,.5);
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.infoMessage button {
  max-width: 200px;
  align-self: center;
}

.message {
  max-width: 400px;
  padding: 40px 60px;
  background: #fff;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}

.instructions {
  font-family: "Helvetica Neue", sans-serif;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.4em;
  margin: 20px 0;
  text-align: center;
}

.text {
  font-family: "Helvetica Neue", sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 1.4em;
  margin: 30px 0;
  text-align: center;
}

.image {
  margin: 0 auto;
  height: 30px;
  width: 30px;
}

hr {
  margin: 0;
}
